import { render } from "./MainRelease.vue?vue&type=template&id=a999fad8&scoped=true&ts=true"
import script from "./MainRelease.vue?vue&type=script&lang=ts"
export * from "./MainRelease.vue?vue&type=script&lang=ts"

import "./MainRelease.vue?vue&type=style&index=0&id=a999fad8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a999fad8"]])

export default __exports__